export class ProgressClockApp {
    targetTime: number;
    totalTime: number;
    totalTimeSeconds: number = 0;
    intervalHandler: any | null = null;
    intervalFunction: (forceRun: boolean) => void = () => {};

    constructor(totalTimeSeconds: number | null = null) {
        this.targetTime = Date.now();
        this.totalTime = 0;
        if (totalTimeSeconds !== null) {
            this.totalTime = totalTimeSeconds * 1000;
            this.targetTime = Date.now() + totalTimeSeconds * 1000;
            this.totalTimeSeconds = totalTimeSeconds;
        }
    }

    public reset(totalTimeSeconds: number | null = null): this {
        if (totalTimeSeconds !== null) {
            this.totalTimeSeconds = totalTimeSeconds;
        }
        this.totalTime = this.totalTimeSeconds * 1000;
        this.targetTime = Date.now() + this.totalTimeSeconds * 1000;
        if (this.intervalHandler) {
            clearInterval(this.intervalHandler);
        }
        this.intervalHandler = setInterval(() => {
            if (typeof this.intervalFunction === 'function') {
                this.intervalFunction(false);
            }
            if (this.getRemainingSeconds() <= 0) {
                clearInterval(this.intervalHandler);
            }
        }, 1000);
        return this;
    }

    public callIntervalFunction(forceRun: boolean = false): this {
        if (typeof this.intervalFunction === 'function') {
            this.intervalFunction(forceRun);
        }
        return this;
    }

    public stop(): this {
        if (this.intervalHandler) {
            clearInterval(this.intervalHandler);
        }
        this.totalTime = 0;
        return this;
    }

    public setIntervalFunction(callback: (forceRun: boolean) => void, run: boolean = false): this {
        this.intervalFunction = callback;
        if (run) {
            this.reset();
        }
        return this;
    }

    public getRemainingSeconds(): number {
        return Math.floor((this.targetTime - Date.now()) / 1000);
    }

    public isRunning(): boolean {
        return this.totalTime > 0;
    }

    public getRemainingPercent(): number {
        if (this.totalTime === 0) {
            return 0;
        }
        return Math.max(0, Math.min(100, ((this.targetTime - Date.now()) * 100) / this.totalTime));
    }
}
